import React, { useMemo } from "react";
import { array, arrayOf, shape, string, number, object, bool, oneOf } from "prop-types";
import LandingSimpleSection from "@insightfulscience/atomic-react/LandingElement/SimpleSection";
import Videos from "../../../ui/RecommendedVideos";

const RecommendedVideos = ({ videos, centerShortList = false, titleType = "v1" }) => {
	const center = useMemo(() => centerShortList && videos.length < 4, [videos, centerShortList]);
	const TitleComp = useMemo(
		() => (titleType === "v2" ? LandingSimpleSection.TitleV2 : LandingSimpleSection.Title),
		[titleType],
	);

	return (
		<LandingSimpleSection bgColor="white" isBorderNone>
			<TitleComp>Recommended Resources</TitleComp>
			<Videos items={videos} center={center} />
		</LandingSimpleSection>
	);
};

RecommendedVideos.propTypes = {
	centerShortList: bool,
	titleType: oneOf(["v1", "v2"]),
	videos: arrayOf(
		shape({
			fields: shape({
				body: object, // eslint-disable-line react/forbid-prop-types,
				lead: string,
				metaDescription: string,
				slug: string,
				thumbnail: shape({
					fields: shape({
						description: string,
						file: shape({
							contentType: string,
							details: shape({
								image: shape({
									height: number,
									width: number,
								}),
								size: number,
							}),
							fileName: string,
							url: string,
						}),
						title: string,
					}),
					metadata: shape({
						tags: array, // eslint-disable-line react/forbid-prop-types,
					}),
					sys: object, // eslint-disable-line react/forbid-prop-types,
				}),
				title: string,
				toClick: string,
			}),
			metadata: shape({
				tags: array, // eslint-disable-line react/forbid-prop-types,
			}),
			sys: object, // eslint-disable-line react/forbid-prop-types,
		}),
	),
};

export default RecommendedVideos;
